import { ILopActionTypes } from "../../action-types/category/ILopActions";
import { ILopReducer } from "../../reducer-model/category/ILopReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ILopReducer = {
    status: eReducerStatusBase.is_not_initialization,
    lops: []
}

export const lopReducer = (state: ILopReducer = iniState, action: ILopActionTypes): ILopReducer => {
    switch (action.type) {
        case "LOP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "LOP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lops: action.payload
            };
        case "LOP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
}